import { EMPTY_OBJECT } from 'commons-ui';

export const makeActionHandler = (action: any, params: any) => {
	const { history, rowData = EMPTY_OBJECT } = params;
	switch (action.id) {
		case 'add':
			return () => {
				history.push({
					pathname: `/dashboard/internalUser/add`,
					state: {
						rowData
					}
				});
			};
		case 'edit':
			return () => {
				history.push({
					pathname: `/dashboard/internalUser/edit`,
					state: {
						rowData
					}
				});
			};
		default:
			return () => {};
	}
};

export default {
	makeActionHandler
};
